import { useNavigate, useLocation } from 'react-router-dom'
import { Files, Database } from 'lucide-react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface FileOpsLayoutProps {
  children: React.ReactNode
}

export default function FileOpsLayout({ children }: FileOpsLayoutProps) {
  const navigate = useNavigate()
  const location = useLocation()

  const getActiveTab = () => {
    if (location.pathname.includes('/file-ops/files')) return 'files'
    if (location.pathname.includes('/file-ops/bulk-operations')) return 'bulk-operations'
    return 'files'
  }

  const handleTabChange = (value: string) => {
    navigate(`/file-ops/${value}`)
  }

  return (
    <div className="p-8 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">File Ops</h1>
        <p className="text-muted-foreground mt-1">
          Manage files and perform bulk operations
        </p>
      </div>

      <Tabs value={getActiveTab()} onValueChange={handleTabChange} className="w-full">
        <TabsList className="grid w-full max-w-2xl grid-cols-2">
          <TabsTrigger value="files">
            <Files className="h-4 w-4 mr-2" />
            Files
          </TabsTrigger>
          <TabsTrigger value="bulk-operations">
            <Database className="h-4 w-4 mr-2" />
            Bulk Operations
          </TabsTrigger>
        </TabsList>
      </Tabs>

      {children}
    </div>
  )
}
